/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MenstrualCycleUpsertRequestDto
 */
export interface MenstrualCycleUpsertRequestDto {
    /**
     * Unique identifier for the patient's menstrual cycle record.
     * @type {string}
     * @memberof MenstrualCycleUpsertRequestDto
     */
    id: string;
    /**
     * Cycle regularity and length
     * @type {string}
     * @memberof MenstrualCycleUpsertRequestDto
     */
    cycleRegularityAndLength: string;
    /**
     * Flow Characteristic
     * @type {string}
     * @memberof MenstrualCycleUpsertRequestDto
     */
    flowCharacteristic: string;
    /**
     * Symptoms Experienced
     * @type {string}
     * @memberof MenstrualCycleUpsertRequestDto
     */
    symptomsExperienced: string;
    /**
     * Additional Information
     * @type {string}
     * @memberof MenstrualCycleUpsertRequestDto
     */
    additionalInformation?: string;
    /**
     * Indicates if this update is part of onboarding flow
     * @type {boolean}
     * @memberof MenstrualCycleUpsertRequestDto
     */
    isOnboarding?: boolean;
}

/**
 * Check if a given object implements the MenstrualCycleUpsertRequestDto interface.
 */
export function instanceOfMenstrualCycleUpsertRequestDto(value: object): value is MenstrualCycleUpsertRequestDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('cycleRegularityAndLength' in value) || value['cycleRegularityAndLength'] === undefined) return false;
    if (!('flowCharacteristic' in value) || value['flowCharacteristic'] === undefined) return false;
    if (!('symptomsExperienced' in value) || value['symptomsExperienced'] === undefined) return false;
    return true;
}

export function MenstrualCycleUpsertRequestDtoFromJSON(json: any): MenstrualCycleUpsertRequestDto {
    return MenstrualCycleUpsertRequestDtoFromJSONTyped(json, false);
}

export function MenstrualCycleUpsertRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenstrualCycleUpsertRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'cycleRegularityAndLength': json['cycleRegularityAndLength'],
        'flowCharacteristic': json['flowCharacteristic'],
        'symptomsExperienced': json['symptomsExperienced'],
        'additionalInformation': json['additionalInformation'] == null ? undefined : json['additionalInformation'],
        'isOnboarding': json['isOnboarding'] == null ? undefined : json['isOnboarding'],
    };
}

export function MenstrualCycleUpsertRequestDtoToJSON(json: any): MenstrualCycleUpsertRequestDto {
    return MenstrualCycleUpsertRequestDtoToJSONTyped(json, false);
}

export function MenstrualCycleUpsertRequestDtoToJSONTyped(value?: MenstrualCycleUpsertRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'cycleRegularityAndLength': value['cycleRegularityAndLength'],
        'flowCharacteristic': value['flowCharacteristic'],
        'symptomsExperienced': value['symptomsExperienced'],
        'additionalInformation': value['additionalInformation'],
        'isOnboarding': value['isOnboarding'],
    };
}

